const language = 'arabic';
export const langDir = 'rtl';

export default language;
